export default "__VITE_ASSET__Do7htd1c__"